import React from 'react';
import WebhookProcessManage from '../WebhookProcessManage/WebhookProcessManage';
import { useTranslation } from 'react-i18next';
import {
  GET_WEBHOOK_ACCT_NOTIFICATION_INFO,
  GET_WEBHOOK_ACCT_NOTIFICATIONS,
  PERFORM_ACTION_WEBHOOK_ACCT_NOTIFICATION,
} from '../../utils/ApiEndpoints';
import { pageTypes } from '../../utils/WebhookProcessManageUtil';

const WebhookAcctNotification = () => {
  const { t } = useTranslation();

  const tc = (e, data) => (data ? t(`webhooklogqueue:${e}`, data) : t(`webhooklogqueue:${e}`));

  const topGridAllColumnNames = [
    {
      field: 'id',
      header: tc('ID_HEADER'),
      filterPlaceholder: tc('ID_FILTER_PLACEHOLDER'),
    },
    {
      field: 'glType',
      header: tc('GL_TYPE_HEADER'),
      filterPlaceholder: tc('GL_TYPE_FILTER_PLACEHOLDER'),
    },
    {
      field: 'status',
      header: tc('STATUS_HEADER'),
      filterPlaceholder: tc('STATUS_FILTER_PLACEHOLDER'),
    },
    {
      field: 'realmId',
      header: tc('REALMID_HEADER'),
      filterPlaceholder: tc('REALM_ID_FILTER_PLACEHOLDER'),
    },
    {
      field: 'createdTime',
      header: tc('CREATED_TIME_HEADER'),
      filterPlaceholder: tc('CREATED_TIME_FILTER_PLACEHOLDER'),
    },
    {
      field: 'updatedTime',
      header: tc('UPDATED_TIME_HEADER'),
      filterPlaceholder: tc('UPDATED_TIME_FILTER_PLACEHOLDER'),
    },
  ];

  const bottomGridColumns = [
    { field: 'id', header: 'Id' },
    { field: 'dataChangeId', header: 'Data Change Id' },
    { field: 'entityId', header: 'Entity Id' },
    { field: 'name', header: 'Name' },
    { field: 'operation', header: 'Operation' },
    { field: 'lastUpdated', header: 'Updated Time' },
    { field: 'deletedId', header: 'Deleted Id' },
    { field: 'status', header: 'Data Change Event Status' },
  ];

  return (
    <WebhookProcessManage
      topGridAllColumnNames={topGridAllColumnNames}
      bottomGridAllColumns={bottomGridColumns}
      pageType={pageTypes.webhookAcctNotification}
      loadQueueAPI={GET_WEBHOOK_ACCT_NOTIFICATIONS}
      loadDetailsAPI={GET_WEBHOOK_ACCT_NOTIFICATION_INFO}
      performActionAPI={PERFORM_ACTION_WEBHOOK_ACCT_NOTIFICATION}
      pageHeader={tc('WEBHOOK_ACCT_NOTIFICATION_PAGE_HEADER')}
      topTableHeader={tc('WEBHOOK_ACCT_NOTIFICATION_TOP_TABLE_HEADER')}
      bottomTableHeader={tc('WEBHOOK_ACCT_NOTIFICATION_BOTTOM_TABLE_HEADER')}
      bottomTableEmptyMsg={tc('NO_ROWS_BOTTOM_ACCT_NOTIFICATION_DEFAULT_TEXT')}
      bottomGridKey="datachangeId"
      bottomPaginator={true}
    />
  );
};

export default WebhookAcctNotification;